import { createLogger } from 'redux-logger';

import { getConfig } from '../services/config';

export const shouldLogReduxActions = () => getConfig().logReduxActions;

export const actionLoggerMiddleware = createLogger({
  level: {
    prevState: () => false,
    action: () => false,
    nextState: () => false,
    error: () => 'log',
  },
  titleFormatter: (action) => `${getConfig().bundleName} ${JSON.stringify(action)}`,
});

export default actionLoggerMiddleware;
